<template>
  <div
    id="event-invite-modal"
    class="modal fade"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button @confirmed="closeModal"/>
          <h4>{{ $t('global.createcalendarentry') }}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <!-- Students v-select -->
            <div class="col-xl-12">
              <div class="form-group">
                <v-select
                  v-model="selectedStudents"
                  label="personName"
                  :options="students"
                  v-if="$CONST('CONFIG').APPTYPE === 'Education'"
                  :reduce="(r) => r.id"
                  :placeholder="$t('global.students')"
                  multiple
                >
                  <span slot="no-options">
                    {{ $t('global.taptosearch') }}
                  </span>
                </v-select>
                <label>{{ $t('global.students') }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="d-flex align-items-center">
                <label
                  for="selectAllStudents"
                  class="mb-0 mr-2"
                >
                  {{ $t('global.select_all_students') }}
                </label>
                <input
                  type="checkbox"
                  id="selectAllStudents"
                  v-model="selectAllStudents"
                />
              </div>
            </div>
          </div>

          <div class="row mt-3">
            <!-- Lecturers v-select -->
            <div class="col-xl-12">
              <div class="form-group">
                <v-select
                  v-model="selectedLecturers"
                  label="personName"
                  :options="lecturers"
                  v-if="$CONST('CONFIG').APPTYPE === 'Education'"
                  :reduce="(r) => r.id"
                  :placeholder="$t('global.lecturers')"
                  multiple
                >
                  <span slot="no-options">
                    {{ $t('global.taptosearch') }}
                  </span>
                </v-select>
                <label>{{ $t('global.lecturers') }}</label>
              </div>
            </div>
            <div class="col-xl-12">
              <div class="d-flex align-items-center">
                <label
                  for="selectAllLecturers"
                  class="mb-0 mr-2"
                >
                  {{ $t('global.select_all_lecturers') }}
                </label>
                <input
                  type="checkbox"
                  id="selectAllLecturers"
                  v-model="selectAllLecturers"
                />
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            class="btn btn-default"
            @click="closeModal"
          >
            {{ $t('global.cancel') }}
          </button>
          <button
            class="btn btn-primary"
            @click="sendEvents"
          >
            {{ $t('global.send') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api/Api'
import store from '@/store'
import ModalCloseButton from '@/components/global/ModalCloseButton'
import AppApi from '@/api/AppApi'

export default {
  name: 'EventInviteModal',
  components: {
    ModalCloseButton,
  },
  props: {
    termine: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      students: [],
      lecturers: [],
      selectedStudents: [],
      selectedLecturers: [],
      selectAllStudents: false,
      selectAllLecturers: false,
      shown: false,
    }
  },
  mounted() {
    this.$bus.$on('openEventInviteModal', () => {
      if (!this.shown) this.openModal()
      this.loadPersonen()
    })
  },
  watch: {
    selectAllStudents(val) {
      this.selectedStudents = val ? this.students.map((p) => p.id) : []
    },
    selectAllLecturers(val) {
      this.selectedLecturers = val ? this.lecturers.map((p) => p.id) : []
    },
    selectedStudents(val) {
      this.selectAllStudents = val.length === this.students.length && val.length > 0
    },
    selectedLecturers(val) {
      this.selectAllLecturers = val.length === this.lecturers.length && val.length > 0
    },
  },
  methods: {
    sendEvents() {
      let json = {
        student_ids: this.selectedStudents,
        lecturer_ids: this.selectedLecturers,
        event_ids: this.termine,
      }

      if (json.event_ids.length > 0) {
        AppApi.post('google/calendar', json)
          .then(() => {
            this.$notify({
              type: 'success',
              title: this.$t('global.actionsuccessful'),
              text: this.$t('global.calendarentrysuccess'),
            })

            this.$emit('updated')
          })
          .catch((e) => {
            this.$notify({
              type: 'warn',
              title: this.$t('global.actionfailed'),
              text: this.$t('global.errorwhilecreatingcalendarentries'),
            })
          })
      } else {
        this.$notify({
          type: 'warn',
          title: this.$t('global.actionfailed'),
          text: this.$t('global.noappointmentsselected'),
        })
      }
      this.closeModal()
    },

    loadPersonen() {
      AppApi.get('google/calendar', {
        params: {
          ids: this.termine.join(','),
        },
      }).then((response) => {
        this.students = response.data.students
        this.lecturers = response.data.lecturers
      })
    },

    openModal() {
      this.resetModalState()

      $('#event-invite-modal').modal({
        backdrop: 'static',
        keyboard: false,
      })

      this.shown = true
    },

    closeModal() {
      $('#event-invite-modal').modal('hide')

      this.shown = false
    },

    resetModalState() {
      this.selectedStudents = []
      this.selectedLecturers = []
      this.selectAllStudents = false
      this.selectAllLecturers = false
      this.students = []
      this.lecturers = []
    },
  },
}
</script>

<style></style>
